import React from 'react';
import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { timelineScroller } from '@atlassian/jira-software-deployments-common-table/src/utils/timeline-scroller.tsx';
import { useDateFilter } from '../../controllers/date-filter';
import messages from './messages';

const END_TIMELINE_SCROLL_WINDOW = 100;

const TodayButton = () => {
	const { formatMessage } = useIntl();
	const [dateFilter] = useDateFilter();
	if (dateFilter.type === 'CUSTOM') return null;
	const tooltipContent = formatMessage(messages.tooltip);
	return (
		<Tooltip position="bottom" content={tooltipContent}>
			<Button
				onClick={() => {
					timelineScroller.scrollToPercentages({
						left: END_TIMELINE_SCROLL_WINDOW,
						behavior: 'smooth',
					});
				}}
			>
				{formatMessage(messages.today)}
			</Button>
		</Tooltip>
	);
};

export default TodayButton;
